import type { TenantBranding } from '@/shared/auth/session'

export type BrandImageSlot = 'icon' | 'logo' | 'login_logo'

/**
 * Imagem da marca para a superfície: no fundo escuro prefere a versão `*_dark`
 * e, sem ela, cai na imagem clara.
 */
export function pickBrandImage(
  branding: TenantBranding | undefined,
  slot: BrandImageSlot,
  dark: boolean,
): string | null {
  if (!branding) return null

  const light = { icon: branding.icon_url, logo: branding.logo_url, login_logo: branding.login_logo_url }[
    slot
  ]
  if (!dark) return light

  const darkUrl = {
    icon: branding.icon_dark_url,
    logo: branding.logo_dark_url,
    login_logo: branding.login_logo_dark_url,
  }[slot]

  return darkUrl ?? light
}
